// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__wRFTy","footer":"ChangeClinic_footer__XAXXu"};